<template>
  <div style="margin-bottom: 8px">
    <div class="large-square-text-label-wrap">
      <div
        class="large-square-text-label"
        :style="{
          color: fontColor,
          backgroundColor: backgroundColor,
          border: `2px solid ${fontColor}`,
        }"
      >
        {{ labelText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Quadrangle',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    labelText () {
      return this.item.itemableAttributes.labelText
    },
    fontColor () {
      return this.item.itemableAttributes.backgroundColor
    },
    backgroundColor () {
      return this.item.itemableAttributes.fontColor
    }
  }
}
</script>

<style scoped>
.large-square-text-label-wrap {
  top: -12px;
  right: 8px;
  left: 8px;
  margin: auto -30px;
  position: absolute;
  z-index: 0;
}

.large-square-text-label {
  display: inline-block;
  border-radius: 3px;
  -webkit-box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 3px 0 rgba(0, 0, 0, 0.3);
  padding: 4px 14px 2px;
  font-size: 11px;
  letter-spacing: 2px;
  align-self: center;
}
</style>
